import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type {
	UpdateContactFormFieldsArgs,
	UpdateWidgetSettingsArgs,
} from "../types"

export const widgetSettingsMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateWidgetSettingsArgs }) => {
			await tx.mutate.widgetSettings.update(args)
		},
	),
	updateContactFormFields: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: UpdateContactFormFieldsArgs
		}) => {
			await tx.mutate.widgetSettings.update({
				id: args.id,
				contactFormFields: args.fields,
			})
		},
	),
	generateSigningSecret: defineMutator(async (_opts: { tx: MutatorTx }) => {
		// ONLY SERVER SIDE
	}),
}
